const NESTEDROUTE = {
  createTask: 'on_boarding/creation_of_a_task',
  changeModel: 'boarding_management/change_a_model',
  changeTask: 'boarding_management/edit_a_task',
  changeModel_add_task: 'boarding_management/add_a_task',
  employee_users: 'general_settings/employee_&_users',
  user_default_setting: '/general_settings/departments',
  personal_data: '/employee_directory/personal_data/:user_id?',
  personal_data_ver2:
    '/general_settings/employee_&_users/personal_data/:user_id?',
  company_record: '/general_settings/company_record',
  workshift_calendar: '/general_settings/workshift_calendar',
  new_workshift_calendar: '/general_settings/new_work_shift_calendar',
  add_model: 'boarding_management/add_a_model',
  settings_leave_absence: '/general_settings/leave_absence',
  staff_absence_holiday: '/staff_leave_&_absences/public_holidays',
  create_new_calendar: '/staff_leave_&_absences/public_holidays/new_calendar',
  staff_leave_and_absence_types:
    '/staff_leave_&_absences/staff_leave_and_absence_types',
  new_absence_types:
    '/staff_leave_&_absences/staff_leave_and_absence_types/create_a_new_staff_leave_types',
  staff_leave_profile: '/staff_leave_&_absences/staff_leave_profile',
  create_leave_profile:
    '/staff_leave_&_absences/staff_leave_profile/create_leave_profile',
  add_collaborator: '/employee_directory/add_a_collaborator',
  customize_design: '/general_settings/customize_design',
  modify_active_task: 'on_boarding/modification_of_a_task',
  add_task_succeed: 'boarding_management/add_a_task_succeed',
  change_model_succeed: 'boarding_management/change_a_model_succeed',
  add_model_succeed: 'boarding_management/add_a_model_succeed',
  change_task_succeed: 'boarding_management/edit_a_task_succeed',
  accounts: '/general_settings/accounts',
  create_profile:
    '/staff_leave_&_absences/staff_leave_profile/create_leave_profile',
  staff_leave_types_detail:
    '/staff_leave_&_absences/staff_leave_and_absence_types/detail',
  staff_leave_profile_detail:
    '/staff_leave_&_absences/staff_leave_profile/detail',
  staff_leave_holiday_detail: '/staff_leave_&_absences/public_holidays/detail',
  request_approval_detail: '/request_approval/detail',
  my_request_detail: '/my_request/detail',
  approved_request: '/request_approval/approval_succeed',
  created_request: '/my_request/request_succeed',
  employee_history: '/general_settings/employee_&_users/employee_history',
  change_request: '/my_request/change_request_succeed',
};
export default NESTEDROUTE;
